var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "padding-lr" },
        [
          _c("span", { staticClass: "data-area-label" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("chart.longitude")))]),
            _c("span", [_vm._v(" / ")]),
            _c("span", [_vm._v(" " + _vm._s(_vm.$t("chart.dimension")))]),
            _c("i", {
              staticClass: "el-icon-arrow-down el-icon-delete data-area-clear",
              on: {
                click: function ($event) {
                  return _vm.clearData("locationXaxis")
                },
              },
            }),
          ]),
          _c(
            "draggable",
            {
              staticClass: "drag-block-style",
              attrs: { group: "drag", animation: "300", move: _vm.onMove },
              on: {
                add: _vm.addLocationXaxis,
                update: function ($event) {
                  return _vm.calcData(true)
                },
              },
              model: {
                value: _vm.busiFieldMap.locationXaxis,
                callback: function ($$v) {
                  _vm.$set(_vm.busiFieldMap, "locationXaxis", $$v)
                },
                expression: "busiFieldMap.locationXaxis",
              },
            },
            [
              _c(
                "transition-group",
                { staticClass: "draggable-group" },
                _vm._l(_vm.busiFieldMap.locationXaxis, function (item, index) {
                  return _c("detail-item", {
                    key: item.id,
                    attrs: {
                      param: _vm.param,
                      index: index,
                      item: item,
                      "dimension-data": _vm.dimensionData,
                      "quota-data": _vm.quotaData,
                    },
                    on: { onDetailItemRemove: _vm.locationXItemRemove },
                  })
                }),
                1
              ),
            ],
            1
          ),
          !_vm.busiFieldMap.locationXaxis ||
          _vm.busiFieldMap.locationXaxis.length === 0
            ? _c("div", { staticClass: "drag-placeholder-style" }, [
                _c("span", { staticClass: "drag-placeholder-style-span" }, [
                  _vm._v(_vm._s(_vm.$t("chart.placeholder_field"))),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "padding-lr" },
        [
          _c("span", { staticClass: "data-area-label" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("chart.latitude")) +
                  " / " +
                  _vm._s(_vm.$t("chart.dimension"))
              ),
            ]),
            _c("i", {
              staticClass: "el-icon-arrow-down el-icon-delete data-area-clear",
              on: {
                click: function ($event) {
                  return _vm.clearData("locationYaxis")
                },
              },
            }),
          ]),
          _c(
            "draggable",
            {
              staticClass: "drag-block-style",
              attrs: { group: "drag", animation: "300", move: _vm.onMove },
              on: {
                add: _vm.addLocationYaxis,
                update: function ($event) {
                  return _vm.calcData(true)
                },
              },
              model: {
                value: _vm.busiFieldMap.locationYaxis,
                callback: function ($$v) {
                  _vm.$set(_vm.busiFieldMap, "locationYaxis", $$v)
                },
                expression: "busiFieldMap.locationYaxis",
              },
            },
            [
              _c(
                "transition-group",
                { staticClass: "draggable-group" },
                _vm._l(_vm.busiFieldMap.locationYaxis, function (item, index) {
                  return _c("detail-item", {
                    key: item.id,
                    attrs: {
                      param: _vm.param,
                      index: index,
                      item: item,
                      "dimension-data": _vm.dimensionData,
                      "quota-data": _vm.quotaData,
                    },
                    on: { onDetailItemRemove: _vm.locationYItemRemove },
                  })
                }),
                1
              ),
            ],
            1
          ),
          !_vm.busiFieldMap.locationYaxis ||
          _vm.busiFieldMap.locationYaxis.length === 0
            ? _c("div", { staticClass: "drag-placeholder-style" }, [
                _c("span", { staticClass: "drag-placeholder-style-span" }, [
                  _vm._v(_vm._s(_vm.$t("chart.placeholder_field"))),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }